import context from '@/context'
import { fromUtcDate } from '@/utils/dateUtilities'

export const initialState = {

  collisionDates: [] // array of objects { reportingCycleId: int, fetching: bool, fetched: bool, error: object, dates: [Date] }
}

export const actionTypes = {

  ReportingCycleCollisionFetching: 'reportingCycleCollision/fetching',
  ReportingCycleCollisionFetched: 'reportingCycleCollision/fetched',
  ReportingCycleCollisionError: 'reportingCycleCollision/error'
}

export const actionCreators = {

  getCollisionDates: (id) => (dispatch, getState) => {
    dispatch({ type: actionTypes.ReportingCycleCollisionFetching, data: id })
    context.api.reportingCyclesService.getCollisionDates(id)
      .then(response => {
        // convert dates from string ISO format to Date objects
        const collistionDates = { ...response, dates: response.dates.map(x => fromUtcDate(x)) }
        dispatch({ type: actionTypes.ReportingCycleCollisionFetched, data: collistionDates })
      })
      .catch(error => {
        dispatch({ type: actionTypes.ReportingCycleCollisionError, data: { reportingCycleId: id, error } })
      })
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ReportingCycleCollisionFetching: return { ...state, collisionDates: updateDates(state.collisionDates, action.data, { fetching: true, error: null }) }
    case actionTypes.ReportingCycleCollisionFetched: return { ...state, collisionDates: updateDates(state.collisionDates, action.data.reportingCycleId, { fetching: false, fetched: true, dates: action.data.dates, error: null }) }
    case actionTypes.ReportingCycleCollisionError: return { ...state, collisionDates: updateDates(state.collisionDates, action.data.reportingCycleId, { fetching: false, error: action.data.error }) }

    default: return state
  }
}

export const updateDates = (collisionDates, id, properties) => {
  let isInArray = false
  const newDates = collisionDates.map(item => {
    if (item.reportingCycleId === id) {
      isInArray = true
      return { ...item, ...properties }
    } else {
      return item
    }
  })
  if (!isInArray) {
    newDates.push({ reportingCycleId: id, ...properties })
  }
  return newDates
}



// WEBPACK FOOTER //
// ./src/store/ReportingCycleCollisions.js